<div class="page">
    <!-- Header -->
     <div class="content-wrapper">
       <div class="header">
           <div class="header-item">
               <div class="logo-container">
                   <mtn-banner-image [banner]="store?.banner" [width]="70" [maxHeight]="40" *ngIf="store?.banner?.logoCloudinaryFilename; else noLogo"></mtn-banner-image>
                   <ng-template #noLogo>
                       <fa-icon icon="store-alt" size="2x"></fa-icon>
                   </ng-template>
               </div>
               <div class="header-text">
                   <h3>{{ storeInfo.name }}</h3>
                   <p>{{ store?.banner?.name || 'No Associated Banner' }} - <mtn-definition-view [definitionType]="DefinitionType.FIT" [systemName]="store?.fit" *ngIf="store?.fit; else noFit"></mtn-definition-view><ng-template #noFit>No FIT Category</ng-template></p>
               </div>
           </div>
           <div class="header-item">
               <fa-icon icon="map-marker-alt" size="lg" class="header-icon"></fa-icon>
               <div class="header-text">
                   <h3>{{ storeInfo.address }}</h3>
                   <p>{{ storeInfo.city }}</p>
               </div>
           </div>
           <div class="header-item">
               <fa-icon icon="bags-shopping" size="lg" class="header-icon"></fa-icon>
               <div class="header-text">
                   <h3>{{ storeInfo.location }}</h3>
                   <p>{{ store?.space?.shoppingCenter?.ownerCompany?.name || 'Unknown Owner' }} - <mtn-definition-view [definitionType]="DefinitionType.SHOPPING_CENTER_TYPE" [systemName]="store?.space?.shoppingCenter?.type" *ngIf="store?.space?.shoppingCenter?.type; else noType"></mtn-definition-view><ng-template #noType>Unknown Shopping Center Type</ng-template></p>
               </div>
           </div>
       </div>

       <!-- Critical Insights -->
       <div class="section-header">CRITICAL INSIGHTS</div>
       <div class="insights-container">
           <div class="metrics-column">
               <div class="metric-item" *ngFor="let metric of metricsData; let i = index">
                   <img [src]="getMetricIcon(i)" class="metric-icon" alt="" *ngIf="i < 3">
                   <div class="status-dot" [style.background-color]="getStatusColor()" *ngIf="i === 3"></div>
                   <div class="metric-content">
                       <div class="metric-value">{{ metric.value }}</div>
                       <div class="metric-label">{{ metric.label }}</div>
                   </div>
               </div>
           </div>

           <div class="alerts-column">
               <div class="alert-item" *ngFor="let highlight of highlights | slice:0:10">
                   <div class="alert-icon" [class.positive]="highlight.isPositive">
                       <fa-icon [icon]="highlight.isPositive ? ['fas', 'plus-square'] : ['fas', 'minus-square']"></fa-icon>
                   </div>
                   <div class="alert-content">
                       <div class="alert-title">{{ highlight.title }}</div>
                       <div class="alert-desc">{{ highlight.description }}</div>
                   </div>
               </div>
           </div>
         </div>

       <!-- Sales Performance (show when critical insights <= 4) -->
       <div *ngIf="shouldShowSalesPerformanceInFirstPage()">
           <div class="section-header">SALES PERFORMANCE INSIGHTS</div>
           <div class="performance-section" *ngIf="salesPerformance?.byVolume?.length > 0 || salesPerformance?.bySqft?.length > 0">
               <div class="performance-label">COMPARING BY ESTIMATED SALES VOLUME</div>
               <div class="performance-row">
                   <div class="perf-item" *ngFor="let item of salesPerformance.byVolume">
                       <div class="perf-canvas">
                           <canvas width="40" height="40"
                                   [attr.data-percentile]="item.percentile"
                                   [attr.data-color]="item.color"
                                   class="mini-chart"></canvas>
                           <div class="perf-percentile">{{ item.percentile }}</div>
                       </div>
                       <div class="perf-text">
                           <div class="perf-prefix">This Store is a</div>
                           <div class="perf-title">{{ item.status }}</div>
                           <div class="perf-subtitle">{{ item.description }}</div>
                       </div>
                   </div>
               </div>
               <div class="no-data-message" *ngIf="!salesPerformance?.byVolume?.length">
               Performance cannot be analyzed due to this store missing required data
           </div>
               <div class="performance-label">COMPARING BY ESTIMATED SALES/SQFT</div>
               <div class="performance-row">
                   <div class="perf-item" *ngFor="let item of salesPerformance.bySqft">
                       <div class="perf-canvas">
                           <canvas width="40" height="40"
                                   [attr.data-percentile]="item.percentile"
                                   [attr.data-color]="item.color"
                                   class="mini-chart"></canvas>
                           <div class="perf-percentile">{{ item.percentile }}</div>
                       </div>
                       <div class="perf-text">
                           <div class="perf-prefix">This Store is a</div>
                           <div class="perf-title">{{ item.status }}</div>
                           <div class="perf-subtitle">{{ item.description }}</div>
                       </div>
                   </div>
               </div>
               <div class="no-data-message" *ngIf="!salesPerformance?.bySqft?.length">
               Performance cannot be analyzed due to this store missing required data
           </div>
           </div>
           <div class="no-data-message" *ngIf="!salesPerformance?.byVolume?.length && !salesPerformance?.bySqft?.length">
               Performance cannot be analyzed due to this store missing required data
           </div>
       </div>

       <div class="competitive-pattern-line">
           <div class="pattern-segment"></div>
           <div class="pattern-segment"></div>
     </div>

</div>
